// O WhatsApp entrega um álbum como uma mensagem "não suportada", sem conteúdo,
// seguida de cada foto/arquivo em mensagens próprias. Quando a mídia chega logo
// depois, do mesmo lado da conversa, o aviso é redundante e fica oculto na tela
// (nada é apagado: sem mídia em seguida, ele continua aparecendo).
export const ALBUM_PLACEHOLDER_WINDOW_SECONDS = 60;

const toSeconds = value => {
  const timestamp = Number(value);
  if (!Number.isFinite(timestamp)) return null;
  return timestamp > 1_000_000_000_000 ? timestamp / 1000 : timestamp;
};

const hasAttachments = message =>
  Array.isArray(message.attachments) && message.attachments.length > 0;

const isUnsupportedPlaceholder = message =>
  Boolean(message.contentAttributes?.isUnsupported) && !hasAttachments(message);

export const isAlbumPlaceholder = (message, index, messages) => {
  if (!isUnsupportedPlaceholder(message)) return false;

  const createdAt = toSeconds(message.createdAt);
  if (createdAt === null) return false;

  const limit = createdAt + ALBUM_PLACEHOLDER_WINDOW_SECONDS;
  return messages.slice(index + 1).some(candidate => {
    const candidateAt = toSeconds(candidate.createdAt);
    return (
      candidateAt !== null &&
      candidateAt >= createdAt &&
      candidateAt <= limit &&
      candidate.messageType === message.messageType &&
      hasAttachments(candidate)
    );
  });
};

export const withoutAlbumPlaceholders = messages =>
  messages.filter(
    (message, index) => !isAlbumPlaceholder(message, index, messages)
  );
